import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import * as Yup from "yup";
import { DataContext } from "../DataProviders/DataProvider";

// Create the context
const ConnctedAppsContext = createContext();

// Create the provider
export const ConnectedAppsProvider = ({ children }) => {
  const { orderId, mailId } = useContext(DataContext);
  const urlRegex = /^(?:(?:(?:\w+):)?\/\/)?((?:[\w-]+\.)+[a-z]{2,})(:\d{1,5})?(\/\S*)?$/i;

  const validationSchema1 = Yup.object().shape({
    emailTool: Yup.object().shape({
      loginURL: Yup.string()
        .matches(urlRegex, "Invalid URL format")
        .required("Login URL is required"),
      username: Yup.string().required("Username is required"),
      // password: Yup.string().required("Password is required"),
      workspace: Yup.string(),
      shareAccessConfirmation: Yup.bool()
        // .oneOf([true, false], "You must confirm or decline the delegated access")
        .required("You must confirm or decline the delegated access"),
      delegateAccessConfirmation: Yup.bool()
        .when('shareAccessConfirmation', {
          is: true,
          then: Yup.bool()
            .oneOf([true], "You must confirm the delegated access")
            .required("You must confirm the delegated access"),
          otherwise: Yup.bool().oneOf([false])
        }),
      password: Yup.string().when("shareAccessConfirmation", {
        is: false,
        then: Yup.string()
          .required("Password is required")
          .test(
            "no-email-in-password",
            "Password should not contain an email address",
            (value) => !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(value)
          ),
      })
    }),
    domainRegistrar: Yup.object().shape({
      loginURL: Yup.string()
        .matches(urlRegex, "Invalid URL format")
        .required("Login URL is required"),
      username: Yup.string().required("Username is required"),
      // password: Yup.string().required("Password is required"),
      workspace: Yup.string(),
      shareAccessConfirmation: Yup.bool()
        .required("You must confirm or decline the delegated access"),
      delegateAccessConfirmation: Yup.bool()
        .when('shareAccessConfirmation', {
          is: true,
          then: Yup.bool()
            .oneOf([true], "You must confirm the delegated access")
            .required("You must confirm the delegated access"),
          otherwise: Yup.bool().oneOf([false])
        }),
      password: Yup.string().when("shareAccessConfirmation", {
        is: false,
        then: Yup.string()
          .required("Password is required")
          .test(
            "no-email-in-password",
            "Password should not contain an email address",
            (value) => !/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(value)
          ),
      })


    }),
    // userAvailability: Yup.object().shape({
    //   fromHour: Yup.number().required("From hour is required"),
    //   toHour: Yup.number().required("To hour is required"),
    //   timeZone: Yup.string().required("Time zone is required").nullable(),
    // }),
    userAvailability: Yup.object().shape({
      fromHour: Yup.number().required("From hour is required"),
      toHour: Yup.number()
        .required("To hour is required")
        .test('is-greater', 'End time must be greater than start time', function (toHour) {
          const { fromHour } = this.parent;
          return toHour > fromHour;
        }),
      timeZone: Yup.string().required("Time zone is required").nullable(),
    }),
  });

  const iniialJson = {
    domainRegistrar: {
      id: null,
      loginURL: "",
      username: "",
      password: "",
      workspace: "",
      orderId: orderId,
      email: mailId,
      twoFAEnabledFlag: false,
      shareAccessConfirmation: true,
      delegateAccessConfirmation: false,
    },
    emailTool: {
      id: null,
      loginURL: "",
      username: "",
      password: "",
      workspace: "",
      orderId: orderId,
      email: mailId,
      shareAccessConfirmation: true,
      delegateAccessConfirmation: false,
    },
    userAvailability: {
      id: null,
      orderId: orderId,
      fromHour: 0,
      fromMinute: 0,
      fromSecond: 0,
      toHour: 0,
      toMinute: 0,
      toSecond: 0,
      timeZone: null,
      note: "",
    },
  };

  const [initialValues, setInitialValues] = useState(iniialJson);

  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [availableHours, setAvailableHours] = useState();

  const resetForm = () => {
    setInitialValues({
      domainRegistrar: {
        id: null,
        loginURL: "",
        username: "",
        password: "",
        workspace: "",
        orderId: orderId,
        email: mailId,
        twoFAEnabledFlag: false,
        shareAccessConfirmation: true,
        delegateAccessConfirmation: false,
      },
      emailTool: {
        id: null,
        loginURL: "",
        username: "",
        password: "",
        workspace: "",
        orderId: orderId,
        email: mailId,
        shareAccessConfirmation: true,
        delegateAccessConfirmation: false,
      },
      userAvailability: {
        id: null,
        orderId: orderId,
        fromHour: 0,
        fromMinute: 0,
        fromSecond: 0,
        toHour: 0,
        toMinute: 0,
        toSecond: 0,
        timeZone: null,
        note: "",
      },
    });
  };

  return (
    <ConnctedAppsContext.Provider
      value={{
        initialValues,
        setInitialValues,
        validationSchema1,
        timeZoneOptions,
        setTimeZoneOptions,
        availableHours,
        setAvailableHours,
        resetForm,
      }}
    >
      {children}
    </ConnctedAppsContext.Provider>
  );
};

ConnectedAppsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConnctedAppsContext;
